import { createConfigMap } from '../utils';
import { DESKTOP_CHANNELS, MOBILE_CHANNELS, NATIVE_CHANNELS } from './channels';

export const PROJECT_KEY = 'pm_casino';

export const UPLOAD_CONTENT_API_PREFIX = '/uploads/';

export const AVAILABILITY_DEFAULT_QUERY_PARAM = 'all';
export const AVAILABILITY_LOGIN_QUERY_PARAM = 'login';
export const AVAILABILITY_NON_LOGIN_QUERY_PARAM = 'non_login';

export const ENTITY = {
  SLIDERS: 'casinosliders/list',
  SEO_TEXTS: 'seotexts',
  FAQ: 'faqs',
  METATAGS: 'metatags',
  BONUSES: 'evabonuses',
  BONUS_CATEGORIES: 'evabonuses-categories',
  RULES: 'casinogamerules',
  SC_GAME_WIDGET_BGS: 'smartcasino-backgrounds/list',
  GAME_OF_THE_DAY: 'casino-game-of-the-days',
};

/**
 * We have a "copy" of QUERY object specified for TopSlider because of changing
 * our interaction with CMS (slider's query params differ from our usual query params)
 */
export const SLIDERS_QUERY = {
  FROM: 'from',
  UNTIL: 'until',
  AVAILABILITIES: 'availabilities',
  PROJECT: 'project',
  CHANNEL: 'channel',
  LANGUAGE: 'language',
  BRAND: 'brand',
};

export const QUERY = {
  IS_ACTIVE: 'is_active',
  PROJECT: 'casinoprojects.project_id',
  LANGUAGE_NULL: 'language_null',
  LANGUAGE_SINGLE: 'language.name',
  LANGUAGE: 'languages.language_id',
  // For relations many to many
  CHANNELS: 'channels.name',
  // For relations one to one
  CHANNEL: 'channel.name',
  BRANDS: 'brands.name',
  BRAND: 'brand.name',
  PAGE: 'pagelink.name',
  EXTERNAL_ID_IN: 'external_id_in',
  EXTERNAL_ID: 'external_id',
  GAME_ID: 'gameId',
  PRODUCT_TYPE: 'productType.project_id',
  DAY_TO_SHOW: 'daysToShow.name',
};

export const CHANNEL_CONFIG_MAP = createConfigMap({
  desktop: DESKTOP_CHANNELS,
  mobile: MOBILE_CHANNELS,
  native: NATIVE_CHANNELS,
});
